




























import { defineComponent, computed, PropType } from '@vue/composition-api';
import SocialPlatformsService from '@/services/socialPlatforms/SocialPlatformsService';
import SocialShareType from '@/utils/SocialShareType';
import SocialShareInfo from '@/data/SocialShareInfo';

// @ts-ignore
import LdIcon from '@/assets/icons/linkedin_circle.svg';
// @ts-ignore
import FbIcon from '@/assets/icons/facebook_circle.svg';
// @ts-ignore
import TwIcon from '@/assets/icons/twitter_circle.svg';
// @ts-ignore
import MailIcon from '@/assets/icons/email_circle.svg';
// @ts-ignore
import WechatIcon from '@/assets/icons/wechat_circle.svg';
// @ts-ignore
import WeiboIcon from '@/assets/icons/weibo_circle.svg';
import SharedState from '@/data/SharedState';

export default defineComponent({
  components: {
    LdIcon,
    FbIcon,
    TwIcon,
    MailIcon,
    WechatIcon,
    WeiboIcon
  },
  props: {

    socialShareInfo: {
      type: Object as PropType<SocialShareInfo>,
      required: true
    }
  },
  emits: {
    click: () => true
  },
  setup(props, context) {

    const isSupported = (socialShareType: SocialShareType, countryCode: string) => {
      return SocialPlatformsService.isSupported(socialShareType, countryCode);
    }
    const getDataTarget = (socialShareType: SocialShareType) => {
      return SocialPlatformsService.getDataTarget(socialShareType);
    }
    const getLink = (socialShareType: SocialShareType) => {

      return SocialPlatformsService.getShareLink(
        SharedState.getText(context, 'corptube.share.email.subject'),
        SharedState.getText(context, 'corptube.share.email.body'),
        socialShareType,
        props.socialShareInfo.shareLink,
        props.socialShareInfo.shareTitle,
        props.socialShareInfo.sourceUrl);
    }

    const shareTypes = computed((): Array<SocialShareType> => {

      const a = Object.keys(SocialShareType).filter(key => {
        const shareTypeI = Number(key);
        return !isNaN(shareTypeI) &&
          SocialPlatformsService.isSupported(shareTypeI, props.socialShareInfo.countryCode);
      }).map(key => {
        return Number(key);
      });
      return a;
    });

    const getLinkAttrs = (socialShareType: SocialShareType) => {

      return {
        target: '_blank',
        rel: 'noopener',
        'data-target': getDataTarget(socialShareType),
        href: getLink(socialShareType)
      };
    };

    return {
      isSupported,
      SocialShareType,
      getLinkAttrs,
      shareTypes
    }
  }
});

